import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Playroom } from 'src/app/admin/models/playroom.model';
import { PlayroomService } from 'src/app/admin/services/playroom.service';
import { validateRoom } from 'src/app/utils/formValidators';

@Component({
  selector: 'app-add-playroom-modal',
  templateUrl: './add-playroom-modal.component.html',
  styleUrls: ['./add-playroom-modal.component.scss'],
})
export class AddPlayroomModalComponent implements OnInit {

  room: Playroom = new Playroom();
  errMsg = '';
  name: string;
  address: string;
  telephone: string;

  constructor(private modalController: ModalController, private roomService: PlayroomService) { }

  ngOnInit() {}

  addRoom() {
    const formValidation = validateRoom(this.room);
    this.errMsg = formValidation.errMsg;
    if(formValidation.isValid) {
      this.roomService.addPlayroom(this.room).subscribe(res => {
        this.roomService.getAllPlayrooms();
        this.dismissModal();
      },(err) => {
        JSON.stringify(err.error.title);
      });
    }
  }


  dismissModal() {
    this.modalController.dismiss();
  }


}
